import jwtEncode from "jwt-encode";

const encodeJWT = (...args) => {
  let payload = {
    apiBaseUrl: localStorage.getItem("apiBaseUrl") || "",
    token: localStorage.getItem("token") || "",
    usertoken: localStorage.getItem("user_uuid") || "",
    
  };
  args.forEach(arg => {
    if (arg && typeof arg === 'object') {
      Object.assign(payload, arg); 
    }
  });
  const token = jwtEncode(payload,"");
  return token;
};

export default encodeJWT;
